module["exports"] = [
  "街",
  "路",
  "北路",
  "南路",
  "東路",
  "西路"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_TW/address/street_suffix.js
 ** module id = 1205
 ** module chunks = 0
 **/